export const CANADA_ROUTE_KM = 18000;
export const CANADA_LEG_ONE_KM = 8000;
export const CANADA_LEG_TWO_KM = 2550;
export const CANADA_LEG_THREE_KM = 7450;
export const CANADA_POINT_TWO_KM = CANADA_LEG_ONE_KM;
export const CANADA_POINT_THREE_KM = CANADA_LEG_ONE_KM + CANADA_LEG_TWO_KM;
export const CANADA_ROUTE_POINTS = {
  one: { x: 729, y: 1616 },
  two: { x: 352, y: 1605 },
  three: { x: 319, y: 1527 },
  four: { x: 707, y: 1583 },
};
export const MOON_DISTANCE_KM = 384400;
export const MOON_ORBIT_KM = 11545;
export const RETURN_HOME_KM = MOON_DISTANCE_KM;
export const TOTAL_JOURNEY_KM = CANADA_ROUTE_KM + MOON_DISTANCE_KM + MOON_ORBIT_KM + RETURN_HOME_KM;
export const DEMO_MAX_KM = TOTAL_JOURNEY_KM * 2;
export const DEFAULT_DEMO_KM = 0;

export const journeySegments = {
  canada: {
    startKm: 0,
    endKm: CANADA_ROUTE_KM,
    label: "Across Canada",
  },
  outbound: {
    startKm: CANADA_ROUTE_KM,
    endKm: CANADA_ROUTE_KM + MOON_DISTANCE_KM,
    label: "To The Moon",
  },
  orbit: {
    startKm: CANADA_ROUTE_KM + MOON_DISTANCE_KM,
    endKm: CANADA_ROUTE_KM + MOON_DISTANCE_KM + MOON_ORBIT_KM,
    label: "Moon Orbit",
  },
  return: {
    startKm: CANADA_ROUTE_KM + MOON_DISTANCE_KM + MOON_ORBIT_KM,
    endKm: TOTAL_JOURNEY_KM,
    label: "Return To Earth",
  },
};

export const routeMilestones = [
  { km: 0, label: "Start", ...CANADA_ROUTE_POINTS.one, scale: 1.96 },
  { km: 4000, label: "Halfway to the West Coast", x: 540, y: 1608, scale: 1.96 },
  { km: CANADA_POINT_TWO_KM, label: "Leg #1 Complete", ...CANADA_ROUTE_POINTS.two, scale: 1.96 },
  { km: CANADA_POINT_THREE_KM, label: "Northernmost point on Earth", x: 319, y: 1527, scale: 1.94 },
  { km: 13000, label: "Halfway to the East Coast", x: 482, y: 1554, scale: 1.92 },
  { km: CANADA_ROUTE_KM, label: "Canada Complete", ...CANADA_ROUTE_POINTS.four, scale: 1.88 },
  { km: 18400, label: "International Space Station", x: 742, y: 1542, scale: 1.82 },
  { km: 20000, label: "End of Low Earth Orbit", x: 770, y: 1490, scale: 1.74 },
  { km: 38000, label: "GPS satellite constellation", x: 742, y: 1410, scale: 1.58 },
  { km: 100500, label: "One-quarter of the way to the Moon", x: 780, y: 1270, scale: 1.32 },
  { km: 201000, label: "Halfway to the Moon", x: 732, y: 1040, scale: 1.02 },
  {
    km: 268000,
    label: "Deep cislunar space - Earth's gravity still dominates",
    x: 764,
    y: 860,
    scale: 0.9,
  },
  {
    km: 318000,
    label: "Approaching the Moon - lunar gravity becomes increasingly important",
    x: 704,
    y: 700,
    scale: 0.88,
  },
  {
    km: 344000,
    label: "Earth-Moon L1 region - balance point between Earth and Moon gravity",
    x: 650,
    y: 580,
    scale: 0.92,
  },
  { km: 368000, label: "Final Moon approach", x: 594, y: 410, scale: 1 },
  { km: journeySegments.outbound.endKm, label: "Moon Arrival", x: 520, y: 250, scale: 1.04 },
  { km: 408000, label: "Moon Orbit", x: 520, y: 16, scale: 1.12 },
  { km: journeySegments.orbit.endKm, label: "Return Burn", x: 520, y: 484, scale: 1.02 },
  { km: 500000, label: "Returning Home", x: 348, y: 740, scale: 0.94 },
  { km: 650000, label: "Earthbound", x: 318, y: 1160, scale: 1.12 },
  { km: TOTAL_JOURNEY_KM, label: "Back to Earth", ...CANADA_ROUTE_POINTS.one, scale: 1.52 },
];

export const milestones = routeMilestones.map(({ km, label }) => ({ km, label }));

export const journeyStops = [
  ...routeMilestones,
  {
    km: journeySegments.orbit.startKm + MOON_ORBIT_KM * 0.12,
    x: 754,
    y: 250,
    scale: 1.08,
    hidden: true,
  },
  {
    km: journeySegments.orbit.startKm + MOON_ORBIT_KM * 0.72,
    x: 286,
    y: 250,
    scale: 1.1,
    hidden: true,
  },
].sort((first, second) => first.km - second.km);

function buildRouteSegments(stops) {
  return stops.slice(1).map((end, index) => {
    const start = stops[index];
    const moonCenter = { x: 520, y: 250 };
    const startMoonRadius = Math.hypot(start.x - moonCenter.x, start.y - moonCenter.y);
    const endMoonRadius = Math.hypot(end.x - moonCenter.x, end.y - moonCenter.y);
    const isMoonOrbitSegment =
      start.km >= journeySegments.orbit.startKm &&
      end.km <= journeySegments.orbit.endKm &&
      startMoonRadius > 180 &&
      endMoonRadius > 180;

    if (isMoonOrbitSegment) {
      const radius = 234;
      let startAngle = Math.atan2(start.y - moonCenter.y, start.x - moonCenter.x);
      let endAngle = Math.atan2(end.y - moonCenter.y, end.x - moonCenter.x);

      if (endAngle - startAngle > Math.PI) {
        endAngle -= Math.PI * 2;
      }

      if (endAngle - startAngle < -Math.PI) {
        endAngle += Math.PI * 2;
      }

      const angleDelta = endAngle - startAngle;
      const tangentLength = (4 / 3) * Math.tan(angleDelta / 4) * radius;
      const startTangent = {
        x: -Math.sin(startAngle),
        y: Math.cos(startAngle),
      };
      const endTangent = {
        x: -Math.sin(endAngle),
        y: Math.cos(endAngle),
      };
      const c1 = {
        x: start.x + startTangent.x * tangentLength,
        y: start.y + startTangent.y * tangentLength,
      };
      const c2 = {
        x: end.x - endTangent.x * tangentLength,
        y: end.y - endTangent.y * tangentLength,
      };

      return {
        id: `route-${index + 1}`,
        startKm: start.km,
        endKm: end.km,
        start,
        end,
        c1,
        c2,
        lineClassName: "bcr-route-line",
        d: `M ${start.x} ${start.y} C ${c1.x.toFixed(1)} ${c1.y.toFixed(1)} ${c2.x.toFixed(
          1
        )} ${c2.y.toFixed(1)} ${end.x} ${end.y}`,
      };
    }

    const isOutboundSpaceSegment =
      start.km >= CANADA_ROUTE_KM && end.km <= journeySegments.outbound.endKm;
    const isReturnSpaceSegment =
      start.km >= journeySegments.return.startKm && end.km <= journeySegments.return.endKm;

    if (isOutboundSpaceSegment || isReturnSpaceSegment) {
      const isFinalEarthboundEntry = start.km === 650000 && end.km === TOTAL_JOURNEY_KM;
      if (isFinalEarthboundEntry) {
        const c1 = {
          x: start.x - 58,
          y: interpolateNumber(start.y, end.y, 0.3),
        };
        const c2 = {
          x: end.x - 124,
          y: interpolateNumber(start.y, end.y, 0.72),
        };

        return {
          id: `route-${index + 1}`,
          startKm: start.km,
          endKm: end.km,
          start,
          end,
          c1,
          c2,
          lineClassName: "bcr-route-line",
          d: `M ${start.x} ${start.y} C ${c1.x.toFixed(1)} ${c1.y.toFixed(1)} ${c2.x.toFixed(
            1
          )} ${c2.y.toFixed(1)} ${end.x} ${end.y}`,
        };
      }

      const segmentLength = Math.hypot(end.x - start.x, end.y - start.y) || 1;
      const curveStrength = clamp(segmentLength * 0.46, 54, 150);
      const horizontalDirection = isOutboundSpaceSegment ? 1 : -1;
      const c1 = {
        x: start.x + horizontalDirection * curveStrength,
        y: interpolateNumber(start.y, end.y, 0.34),
      };
      const c2 = {
        x: end.x + horizontalDirection * curveStrength * 0.55,
        y: interpolateNumber(start.y, end.y, 0.68),
      };

      return {
        id: `route-${index + 1}`,
        startKm: start.km,
        endKm: end.km,
        start,
        end,
        c1,
        c2,
        lineClassName: "bcr-route-line",
        d: `M ${start.x} ${start.y} C ${c1.x.toFixed(1)} ${c1.y.toFixed(1)} ${c2.x.toFixed(
          1
        )} ${c2.y.toFixed(1)} ${end.x} ${end.y}`,
      };
    }

    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const length = Math.hypot(dx, dy) || 1;
    const normalX = -dy / length;
    const normalY = dx / length;
    const canadaOffsets = [8, -12, 12, -10, 6];
    const spaceOffsets = [0, -46, 58, -64, 70, -72, 58, -52, 50, -44, 56, -58, 62, -66, 54];
    const offset =
      end.km <= CANADA_ROUTE_KM
        ? canadaOffsets[index % canadaOffsets.length]
        : spaceOffsets[(index - 5 + spaceOffsets.length) % spaceOffsets.length];
    const c1 = {
      x: interpolateNumber(start.x, end.x, 0.34) + normalX * offset,
      y: interpolateNumber(start.y, end.y, 0.34) + normalY * offset,
    };
    const c2 = {
      x: interpolateNumber(start.x, end.x, 0.68) + normalX * offset,
      y: interpolateNumber(start.y, end.y, 0.68) + normalY * offset,
    };

    return {
      id: `route-${index + 1}`,
      startKm: start.km,
      endKm: end.km,
      start,
      end,
      c1,
      c2,
      lineClassName: end.km <= CANADA_ROUTE_KM ? "bcr-canada-route-line" : "bcr-route-line",
      d: `M ${start.x} ${start.y} C ${c1.x.toFixed(1)} ${c1.y.toFixed(1)} ${c2.x.toFixed(
        1
      )} ${c2.y.toFixed(1)} ${end.x} ${end.y}`,
    };
  });
}

export const routeSegments = buildRouteSegments(journeyStops);

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function formatKm(value) {
  return Math.round(value).toLocaleString("en-CA");
}

export function interpolateNumber(start, end, progress) {
  return start + (end - start) * progress;
}

export function getRouteSegmentPoint(segment, progress) {
  const inverse = 1 - progress;
  const startWeight = inverse * inverse * inverse;
  const c1Weight = 3 * inverse * inverse * progress;
  const c2Weight = 3 * inverse * progress * progress;
  const endWeight = progress * progress * progress;

  return {
    x:
      segment.start.x * startWeight +
      segment.c1.x * c1Weight +
      segment.c2.x * c2Weight +
      segment.end.x * endWeight,
    y:
      segment.start.y * startWeight +
      segment.c1.y * c1Weight +
      segment.c2.y * c2Weight +
      segment.end.y * endWeight,
  };
}

export function getLapDetails(totalDistanceKm) {
  const safeDistance = Math.max(Number(totalDistanceKm) || 0, 0);
  const completedLapCount = Math.floor(safeDistance / TOTAL_JOURNEY_KM);
  const rawDistanceInLap = safeDistance % TOTAL_JOURNEY_KM;

  if (safeDistance > 0 && rawDistanceInLap === 0) {
    return {
      completedLapCount: completedLapCount - 1,
      currentLap: completedLapCount,
      distanceInLap: TOTAL_JOURNEY_KM,
      totalDistanceKm: safeDistance,
    };
  }

  return {
    completedLapCount,
    currentLap: completedLapCount + 1,
    distanceInLap: rawDistanceInLap,
    totalDistanceKm: safeDistance,
  };
}

export function getJourneyCamera(totalDistanceKm) {
  const { distanceInLap } = getLapDetails(totalDistanceKm);
  const safeDistance = clamp(distanceInLap, 0, TOTAL_JOURNEY_KM);

  for (let index = 0; index < routeSegments.length; index += 1) {
    const segment = routeSegments[index];
    const { start, end } = segment;

    if (safeDistance <= segment.endKm) {
      const segmentProgress = (safeDistance - segment.startKm) / (segment.endKm - segment.startKm || 1);
      const easedProgress = segmentProgress * segmentProgress * (3 - 2 * segmentProgress);
      const point = getRouteSegmentPoint(segment, easedProgress);

      return {
        x: point.x,
        y: point.y,
        scale: interpolateNumber(start.scale, end.scale, easedProgress),
      };
    }
  }

  return journeyStops[journeyStops.length - 1];
}

export function getJourneyStats(totalDistanceKm) {
  const lapDetails = getLapDetails(totalDistanceKm);
  const { distanceInLap } = lapDetails;

  if (distanceInLap <= journeySegments.canada.endKm) {
    return {
      ...lapDetails,
      phase: journeySegments.canada.label,
      fromEarth: 0,
      toMoon: MOON_DISTANCE_KM,
      line: "The group is crossing Canada before launching towards the Moon.",
    };
  }

  if (distanceInLap <= journeySegments.outbound.endKm) {
    const outboundProgress = distanceInLap - journeySegments.outbound.startKm;

    return {
      ...lapDetails,
      phase: journeySegments.outbound.label,
      fromEarth: outboundProgress,
      toMoon: MOON_DISTANCE_KM - outboundProgress,
      line: "The group has left Earth and is climbing toward the moon.",
    };
  }

  if (distanceInLap <= journeySegments.orbit.endKm) {
    return {
      ...lapDetails,
      phase: journeySegments.orbit.label,
      fromEarth: MOON_DISTANCE_KM,
      toMoon: 0,
      line: "The group has reached the moon and is completing an orbit.",
    };
  }

  const returnProgress = distanceInLap - journeySegments.return.startKm;

  return {
    ...lapDetails,
    phase: journeySegments.return.label,
    fromEarth: Math.max(MOON_DISTANCE_KM - returnProgress, 0),
    toMoon: returnProgress,
    line:
      distanceInLap >= TOTAL_JOURNEY_KM
        ? "The group has returned to Earth. The next kilometer starts a new lap."
        : "The group is heading back toward Earth to finish this lap.",
  };
}

export function getJourneyPercent(totalDistanceKm) {
  const { distanceInLap } = getLapDetails(totalDistanceKm);
  return (clamp(distanceInLap, 0, TOTAL_JOURNEY_KM) / TOTAL_JOURNEY_KM) * 100;
}
